import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'nps',
  children: {
    item: {
      path: ':id',
    },
  },
} as const satisfies Location
